<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :src="image"
    app
    color="grey darken-2"
    dark
    floating
    mobile-break-point="991"
    persistent
    width="260"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>

    <template>
      <v-card color="dark-gray" tile>
        <v-list-item class="justify-center">
          <v-list-item-avatar color="white" size="64" class="mx-auto">
            <v-img src="logo-color.svg" width="64" height="64" contain />
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item class="mt-n4">
          <v-list-item-title class="text-center white--text font-weight-bold">{{ this.getUsername() }}</v-list-item-title>
        </v-list-item>
      </v-card>
    </template>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item active-class="primary darken-4 white--text" to="/">
        <v-list-item-action class="me-3">
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title>Inicio</v-list-item-title>
      </v-list-item>

      <v-list-item active-class="primary darken-4 white--text" to="/consultas">
        <v-list-item-action class="me-3">
          <v-icon>mdi-database-search</v-icon>
        </v-list-item-action>
        <v-list-item-title>Consultas</v-list-item-title>
      </v-list-item>

      <v-list-item active-class="primary darken-4 white--text" to="/assets">
        <v-list-item-action class="me-3">
          <v-icon>mdi-remote</v-icon>
        </v-list-item-action>
        <v-list-item-title>Assets</v-list-item-title>
      </v-list-item>

      <v-list-item active-class="primary darken-4 white--text" to="/vehiculos">
        <v-list-item-action class="me-3">
          <v-icon>mdi-truck</v-icon>
        </v-list-item-action>
        <v-list-item-title>Vehiculos</v-list-item-title>
      </v-list-item>

      <v-list-item active-class="primary darken-4 white--text" to="/usuarios">
        <v-list-item-action class="me-3">
          <v-icon>mdi-account</v-icon>
        </v-list-item-action>
        <v-list-item-title>Usuarios</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item active-class="primary darken-4 white--text" @click="disconnect">
        <v-list-item-action class="me-3">
          <v-icon>mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-title>Cerrar sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      },
    },
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    ...mapGetters('login', ['getUsername']),
    disconnect() {
      this.$store.commit('login/USER_DISCONNECT')
      this.$router.push({ name: 'login' })
      location.assign('/')
    },
  },
}
</script>
